module.exports = __webpack_public_path__ + "img/administrator.858b1026.png";